export default class Historico {
  constructor(id='', descricao='', instante = '', usuario = '') {
    this.id = id;
    this.descricao = descricao;
    this.instante = instante;
    this.usuario = usuario;
  }
}
